import * as fromDatatype from '../datatype-library';

export interface bl_fi_deposit_register_hdr_gendoc_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    deposit_register_hdr_guid: fromDatatype.GuidDataFieldInterface;
    gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
}

export class bl_fi_deposit_register_hdr_gendoc_link_RowClass implements bl_fi_deposit_register_hdr_gendoc_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    deposit_register_hdr_guid: fromDatatype.GuidDataFieldInterface;
    gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
}
